import { Box, Image, Pressable } from 'native-base'
import { useContext } from 'react'
import { isMobile } from 'react-device-detect'

import { AppContext } from '../context/AppContext'
import { trackEvent } from '../utils/analytics-v2'
import { useScreenSize } from '../utils/displayUtils'
import { LoginButton } from './Instructions/LoginButton'

/** Top navigation bar showing the Veho logo and, when authenticated, a login/logout button. */
export default function NavBar() {
  const screenSize = useScreenSize()
  const isMobileScreen = isMobile || screenSize.width < 1000
  const { order } = useContext(AppContext)

  const handleLinkClick = (href: string) => {
    trackEvent('navigate_to_main_site', { element: 'logo' })
    window.open(href, '_self')
  }
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: isMobileScreen ? '100%' : '50%',
        alignItems: 'center',
      }}
      px={3}
    >
      <Box display="flex" justifyContent="center">
        <Pressable
          id="vehoMarketing"
          onPress={() => {
            handleLinkClick('https://www.shipveho.com/')
          }}
        >
          <Image source={{ uri: 'veho-logo.svg' }} resizeMode="contain" size="md" alt="Logo" />
        </Pressable>
      </Box>
      {
        // hide login button until user has queried for an order
        order?.orderId?.length && order?.instructionEditsAllowed ? (
          <LoginButton orderHasPiiFields={order?.address?.street && order?.address?.name ? true : false} />
        ) : null
      }
    </Box>
  )
}
